$(document).ready(function () {
  $(".gallery__slider").slick({
    slidesToShow: 4,
    arrows: false,
    dots: false,
    autoplay: true,
    centerMode: true,
    responsive: [
      {
        breakpoint: 811,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 431,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });
  $(".services__slider").slick({
    slidesToShow: 4,
    arrows: false,
    dots: false,
    autoplay: true,
    centerMode: true,
    responsive: [
      {
        breakpoint: 1081,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 811,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 601,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });
  $(".team__inner").slick({
    slidesToShow: 5,
    arrows: false,
    dots: false,
    autoplay: true,
    centerMode: true,
    responsive: [
      {
        breakpoint: 1281,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 651,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });
  $(".works__slider").slick({
    slidesToShow: 5,
    arrows: false,
    dots: false,
    autoplay: true,
    centerMode: true,
    variableWidth: true,
  });
});

// Anchor Scrolling
function initAnchorScrolling() {
  $('a[href*="#"]')
    // Remove links that don't actually link to anything
    .not('[href="#"]')
    .not('[href="#0"]')
    .click(function (event) {
      // On-page links
      if (
        location.pathname.replace(/^\//, "") ==
          this.pathname.replace(/^\//, "") &&
        location.hostname == this.hostname
      ) {
        // Figure out element to scroll to
        var target = $(this.hash);
        target = target.length
          ? target
          : $("[name=" + this.hash.slice(1) + "]");
        // Does a scroll target exist?
        if (target.length) {
          // Only prevent default if animation is actually gonna happen
          event.preventDefault();
          $("html, body").animate(
            {
              scrollTop: target.offset().top,
            },
            1000,
            function () {
              // Callback after animation
              // Must change focus!
              var $target = $(target);
              $target.focus();
              if ($target.is(":focus")) {
                // Checking if the target was focused
                return false;
              } else {
                $target.attr("tabindex", "-1"); // Adding tabindex for elements not focusable
                $target.focus(); // Set focus again
              }
            }
          );
        }
      }
    });
}

// Burger Menu
function initHamburger() {
  const activeClass = "active";
  const $button = $(".burger__button");
  const $navContainer = $(".header__nav");
  const $navItems = $(".header__link");

  function toggleActiveClass() {
    [$button, $navContainer].forEach((item) => item.toggleClass(activeClass));
  }

  $button.click(toggleActiveClass);
  $navItems.click(toggleActiveClass);
}

$(document).ready(function () {
  initHamburger();
  initAnchorScrolling();
});
